import { TaxonomyIdItem } from "@amzn/taxonomy-lib";
import { ListModel, Visibility } from "lib/models/list-models";
import { CatalogicalDomain, CatalogicalService, UserPermissions } from "lib/services";
import { GetItemResponse, ItemModel } from "lib/services/catalogical-models";
import { useCallback, useEffect, useState } from "react";

import exampleList from "./list-example.json";

export const useLists = () => {
  const [lists, setLists] = useState<ListModel[]>([]);
  const [loading, setLoading] = useState(false);

  const getLists = useCallback(async () => {
    setLoading(true);
    try {
      // TODO: Replace with actual API call
      const mockLists = exampleList as unknown as ListModel[];
      setLists(mockLists);
    } catch (error) {
      console.error("Error fetching lists:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const createList = useCallback((data: { name: string; description: string; visibility: Visibility }) => {
    if (!UserPermissions.current.username) {
      console.error("Cannot create list: User not authenticated");
      throw new Error("User authentication required to create lists");
    }

    const newList: Partial<ListModel> = {
      name: data.name,
      description: data.description,
      visibility: data.visibility,
      itemCount: 0,
      items: [],
      ownerAlias: UserPermissions.current.username,
    };
    console.log("Created list:", newList);
  }, []);

  const updateList = useCallback(
    (taxonomyId: string, data: { name: string; description: string; visibility: Visibility }) => {
      setLists((prevLists) =>
        prevLists.map((list) =>
          list.taxonomyId === taxonomyId
            ? { ...list, name: data.name, description: data.description, visibility: data.visibility }
            : list
        )
      );
      // TODO: Add actual API call here
      console.log("Updated list:", taxonomyId, data);
    },
    []
  );

  const deleteList = useCallback((taxonomyId: string) => {
    // TODO: Implement list delete logic
  }, []);

  const removeItemFromList = useCallback((itemTaxonomyId: string) => {
    // TODO: Implement remove item from list logic
  }, []);

  const useCatalogItem = (taxonomyId: string) => {
    const [catalogItem, setCatalogItem] = useState<GetItemResponse<ItemModel> | null>(null);
    const [itemLoading, setItemLoading] = useState(false);
    const taxonomyIdItem = new TaxonomyIdItem(taxonomyId);

    useEffect(() => {
      const fetchItem = async () => {
        setItemLoading(true);
        try {
          const catService = new CatalogicalService(taxonomyIdItem.dataDomain as CatalogicalDomain);
          const result = await catService.getCatalogItemByTaxonomyId(taxonomyIdItem);
          setCatalogItem(result || null);
        } catch (error) {
          console.error("Error fetching catalog item:", error);
        } finally {
          setItemLoading(false);
        }
      };

      fetchItem();
    }, [taxonomyId]);

    return { catalogItem, itemLoading };
  };

  return {
    lists,
    loading,
    getLists,
    createList,
    updateList,
    deleteList,
    removeItemFromList,
    useCatalogItem,
  };
};
